module.exports = __webpack_public_path__ + "img/teaser_training1.a1c8d363.jpg";